// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3L-cQ","requiredAsterisk":"Info_requiredAsterisk__3kCLB"};